import { Component, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { RespSignup } from "../model/auth.model";
import { AuthService } from "../service/auth.service";

@Component({
  selector: "app-auth-sig-up",
  templateUrl: "./auth-sig-up.component.html",
  styleUrls: ["./auth-sig-up.component.css"],
})
export class AuthSigUpComponent implements OnInit {
  // country = new FormControl("", [Validators.required]);
  // geospatialDataList: GeospatialData[] = [];
  // filteredOptions: Observable<string[]>;
  // geospatialDataCountryList: { index: string; name: string }[] = [];

  // colorMessage: string;
  // messageShow: boolean;
  // notification: string;

  username = new FormControl("", [Validators.required]);
  password_a = new FormControl("", [Validators.required]);
  password_b = new FormControl("", [Validators.required]);
  email = new FormControl("", [Validators.required, Validators.email]);
  first_name = new FormControl("", [Validators.required]);
  last_name = new FormControl("", [Validators.required]);
  // affiliationId = new FormControl("");
  // affiliationName = new FormControl();
  // affiliationNameOther = new FormControl();
  // affiliationCenterId = new FormControl();

  // orcid = new FormControl('');

  // registering = false;

  // parameterAffiliation: Parameter[] = [];
  // parameterCgiarCenter: Parameter[] = [];

  constructor(private authService: AuthService, private router: Router) { }
  hide = true;
  ngOnInit(): void { }

  signUp() {
    // this.registering = true;

    if (this.password_a.value == this.password_b.value) {
      this.authService
        .signup({
          username: this.username.value,
          password: this.password_a.value,
          email: this.email.value,
          first_name: this.first_name.value,
          last_name: this.last_name.value,
        })
        .subscribe((_response: RespSignup) => {
          if (_response.success) {
            this.router.navigate(["/inicio"]);
          }
        });
    }
  }

  goSignIn() {
    this.router.navigate(["/sign-in"]);
  }
}
